<template>
  <div>
    <div class="create-credentials">
      <div class="ri-large-headline ri-alte padding-horizontal-ml padding-top-ml padding-bottom-sm">
        חשבונות האשראי המחוברים לשירות
      </div>
      <div class="add-credit-card-description">
        <div class="subtitle ri-large-body">הגישה לחשבונות האשראי מאפשרת למערכת להציג לך את ההוצאות בצורה מדויקת ועדכנית</div>
      </div>
    </div>
    <template v-if="hasCreditCards">
      <div class="account">חשבונות אשראי מחוברים</div>
      <div v-for="credentials in connectedCreditCards" :key="credentials._id">
        <connected-credentials-card
                                    class="credit-card-wrapper"
                                    :source-type="'card'"
                                    :name="credentials.name"
                                    :sourceName="credentials.sourceName"
                                    :status="credentials.status"
                                    :accounts="credentials.accounts"/>
      </div>
    </template>
    <div class="missing-creds padding-ml">
      <div class="account" v-if="nonConnectedExpenses.length > 0">חשבונות האשראי שמהערכת זיהתה</div>
      <div v-for="(creditCardExpenses, sourceName) in expensesBySource" :key="sourceName">
        <none-connected-credit-card-source-card
          class="margin-bottom-ml"
          :source-name="sourceName"
          :connect-credit-card="() => openCreateCredentialsFlow(sourceName)"
          :credit-card-expenses="creditCardExpenses"/>
      </div>
  </div>
    <div class="padding-ml">
      <riseup-button title="אפשר להמשיך"
                     :loading="isLoading"
                     :disabled="!hasValidCreds"
                     @click="nextPage"/>
    </div>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment/moment';
import NoneConnectedCreditCardSourceCard from '@/base-components/onboarding/NoneConnectedCreditCardSourceCard.vue';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow.vue';
import ConnectedCredentialsCard from '@/base-components/onboarding/ConnectedCredentialsCard.vue';
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';

export default {
  name: 'OTSMissingCardsConnection',
  components: { ConnectedCredentialsCard, NoneConnectedCreditCardSourceCard, RiseupButton: BaseUI.RiseupButton },
  async created() {
    Segment.trackUserGot('OTS_MIssingCredsStepEntered');
    await this.fetchCreditCardsExpenses();
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters('credentials', ['latestScrapedAt']),
    ...mapGetters('credentialsNew', ['hasValidCreds', 'credentialsConfigurations']),
    ...mapGetters('creditCardExpenses', ['expensesBySource', 'nonConnectedExpenses']),
    hasCreditCards() {
      return this.numOfConnectedCreditCards > 0 || this.numOfConnectedBankCards > 0;
    },
    shouldTriggerScrape() {
      return !this.latestScrapedAt || moment().diff(this.latestScrapedAt, 'days') >= 3;
    },
    connectedCreditCards() {
      return this.credentialsConfigurations.filter(cred => cred.type === 'card');
    },
  },
  methods: {
    ...mapActions('creditCardExpenses', ['fetchCreditCardsExpenses']),
    ...mapActions('modalRootStore', ['openModal']),
    openCreateCredentialsFlow(sourceName) {
      this.openModal({
        component: AddCredentialsFlow,
        popupAlignment: 'full-screen',
        props: {
          sourceNameToAdd: sourceName,
        },
        eventHandlers: {
          success: async () => {
            this.isLoading = true;
            await this.fetchCredentialsSettings();
            this.isLoading = false;
          },
        },
      });
    },
    async nextPage() {
      this.isLoading = true;
      this.$emit('nextPage');
    },
  },
};
</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';

.create-credentials {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $riseup_dark_green;

  .add-credit-card-description {
    @include responsive-padding;

    .subtitle {
      margin-bottom: 40px;
    }
  }
}

.missing-creds{
  background-color: $riseup_beige;

  .account {
    font-size: 14px;
    font-weight: bold;
    color: $riseup_black;
    margin: 30px 0 30px;
  }
}
</style>
